<template>
  <div>
    <!-- Drawer抽屉 -->
    <Drawer :title="title" v-model="visible" width="720" draggable>
      <div :style="{ maxHeight: maxHeight }" class="drawer-content">
        <div class="drawer-header">
          <div style="margin-right: 16px">基本信息</div>
        </div>
        <Form
          ref="form"
          :model="form"
          :rules="formValidate"
          label-position="top"
        >
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="机构类型" prop="organizationTypeName">
                <Input v-model="form.organizationTypeName" readonly></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="机构名称" prop="orgName">
                <Input v-model="form.orgName" readonly />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="过期时间" prop="expireTime">
                <Input v-model="form.expireTime" readonly></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="设备数量限制" prop="maxDeviceCount">
                <Input v-model="form.maxDeviceCount" readonly></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="负责人名字" prop="leaderName">
                <Input v-model="form.leaderName" readonly />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="负责人电话" prop="leaderPhone">
                <Input v-model="form.leaderPhone" readonly />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="负责人email" prop="email">
                <Input v-model="form.email" readonly />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="描述信息" prop="description">
                <Input v-model="form.description" readonly />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="管理员账号" prop="adminAccount">
                <Input v-model="form.adminAccount" clearable />
              </FormItem>
            </Col>
          </Row>
          <div class="drawer-header">
            <div style="margin-right: 16px">地理信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="省市区" prop="location">
                <!-- <Input v-model="form.location" readonly></Input> -->
                <al-cascader
                  readonly
                  v-model="form.location"
                  data-type="all"
                  level="2"
                  transfer
                  @on-change="locationChange"
                />
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="详细地址信息" prop="address">
                <Input v-model="form.address" readonly />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="坐标(经度,纬度)" prop="position">
                <Input v-model="form.position" readonly />
              </FormItem>
            </Col>
          </Row>
          <div class="drawer-header">
            <div style="margin-right: 16px">租户信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="" prop="tenantName">
                <Input v-model="form.tenantName" readonly />
              </FormItem>
            </Col>
          </Row>
          <div class="drawer-header">
            <div style="margin-right: 16px"></div>
          </div>

          <div class="drawer-header">
            <div style="margin-right: 16px">相关信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="营业执照图片url" prop="businessImageUrl">
                <upload-pic-input
                  v-model="form.businessImageUrl"
                  style="width: 400px"
                  :readonly="true"
                  :showUploadBtn="false"
                ></upload-pic-input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="logo图片url" prop="logoImageUrl">
                <upload-pic-input
                  v-model="form.logoImageUrl"
                  style="width: 400px"
                  :readonly="true"
                  :showUploadBtn="false"
                ></upload-pic-input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="24">
              <FormItem label="json数据" prop="jsonData">
                <!--                <Input v-model="form.logoImageUrl" clearable/>-->
                <jsonEditor :jsonData="form.jsonData"></jsonEditor>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <!-- <div class="drawer-footer br" v-show="type != '0'">
        <Button type="primary" :loading="submitLoading" @click="submit"
          >提交</Button
        >
        <Button @click="visible = false">取消</Button>
      </div> -->
    </Drawer>
  </div>
</template>

<script>
// import dict from "@/views/my-components/jmbase/dict";
// import uploadPicInput from "@/views/my-components/jmbase/upload-pic-input";
import { getTenantList, addOrg, editOrg } from "@/api/index";
import jsonEditor from "./components/jsonEditor.vue";

let dict = window.jinmabasecomponents.components.dict;
let uploadPicInput = window.jinmabasecomponents.components.uploadPicInput;
export default {
  name: "detail",
  components: {
    uploadPicInput,
    dict,
    jsonEditor,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
    },
    type: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      tenantResult: [],
      tenantList: [],
      // govList: [],
      visible: this.value,
      title: "",
      submitLoading: false,
      maxHeight: 510,
      form: {
        // 添加或编辑表单对象初始化数据
        orgName: "",
        adminAccount: "",
        organizationType: "",
        expireTime: "",
        maxDeviceCount: 0,
        leaderName: "",
        leaderPhone: "",
        email: "",
        description: "",
        location: [],
        address: "",
        hubUrl: "",
        apiUrl: "",
        webUrl: "",
        businessImageUrl: "",
        logoImageUrl: "",
        // govId: "",
        deployType: "",
        tenantId: "",
        position: "",
        longitude: 0,
        latitude: 0,
        provinceCode: "",
        provinceName: "",
        cityCode: "",
        cityName: "",
        countyCode: "",
        countyName: "",
        organizationTypeName: "",
        // govName: "",
        jsonData: "",
      },
      // 表单验证规则
      formValidate: {
        orgName: [{ required: true, message: "不能为空", trigger: "change" }],
        adminAccount: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        tenantId: [{ required: true, message: "不能为空", trigger: "change" }],
        organizationType: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        /* expireTime: [{type: "date", required: true, message: "不能为空", trigger: "change"}],*/
        maxDeviceCount: [
          {
            type: "number",
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
        // hubUrl: [{required: true, message: "不能为空", trigger: "change"}],
        // apiUrl: [{required: true, message: "不能为空", trigger: "change"}],
        address: [{ required: true, message: "不能为空", trigger: "change" }],
        position: [{ required: true, message: "不能为空", trigger: "change" }],
      },
    };
  },
  methods: {
    remoteTenantMethod(query) {
      if (query !== "") {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          const list = this.tenantList.map((item) => {
            return {
              value: item.id,
              label: item.name,
            };
          });
          this.tenantResult = list.filter(
            (item) => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          );
        }, 200);
      } else {
        this.tenantResult = this.tenantList;
      }
    },
    govChange(govInfo) {
      this.form.govName = govInfo.label;
    },
    orgTypeChange(orgVal, dictData) {
      let form = this.form;
      dictData.forEach(function (dict) {
        if (dict.value == orgVal) {
          form.organizationTypeName = dict.title;
        }
      });
    },
    locationChange(locations) {
      let province = locations[0];
      let city = locations[1];
      let county = locations[2];
      this.form.provinceCode = province.code;
      this.form.provinceName = province.name;
      this.form.cityCode = city.code;
      this.form.cityName = city.name;
      this.form.countyCode = county.code;
      this.form.countyName = county.name;
      if (this.form.address.length <= 0) {
        this.form.address =
          province.name + city.name + county.name + " " + this.form.address;
      }
    },
    mapClick(position) {
      let postions = position.split(",");
      this.form.longitude = postions[0];
      this.form.latitude = postions[1];
    },
    init() {
      let input = {
        pageNumber: 1,
        pageSize: 5000,
        sort: "createTime",
        order: "desc",
      };
      getTenantList(input).then((res) => {
        this.loading = false;
        if (res.success) {
          this.tenantList = res.result.records;
        }
      });
    },
    submit() {
      if (typeof this.form.orgDevicePermissionVOS == "string") {
        if (this.form.orgDevicePermissionVOS === "") {
          this.form.orgDevicePermissionVOS = null;
        }
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (typeof this.form.expireTime == "object") {
            this.form.expireTime = this.format(
              this.form.expireTime,
              "yyyy-MM-dd HH:mm:ss"
            );
          }
          if (this.type == "1") {
            // 编辑
            this.submitLoading = true;
            editOrg(this.form).then((res) => {
              this.submitLoading = false;

              if (res.success) {
                this.$Message.success("操作成功");
                this.$emit("on-submit", true);
                this.visible = false;
              }
            });
          } else {
            // 添加
            this.submitLoading = true;
            addOrg(this.form).then((res) => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.$emit("on-submit", true);
                this.visible = false;
              }
            });
          }
        }
      });
    },
    setCurrentValue(value) {
      if (value === this.visible) {
        return;
      }
      if (this.type == "1") {
        this.title = "编辑";
        this.maxHeight =
          Number(document.documentElement.clientHeight - 121) + "px";
      } else if (this.type == "2") {
        this.title = "添加";
        this.maxHeight =
          Number(document.documentElement.clientHeight - 121) + "px";
      } else {
        this.title = "详细信息";
        this.maxHeight = "100%";
      }
      // 清空数据
      this.$refs.form.resetFields();
      if (this.type == "0" || this.type == "1") {
        let location = [
          this.data.provinceCode,
          this.data.cityCode,
          this.data.countyCode,
        ];
        if (location[0] != "") {
          this.data.location = location;
        }
        // 回显数据处理
        this.form = this.data;
        this.form.position = this.data.longitude + "," + this.form.latitude;
      } else {
        // 添加
        delete this.form.id;
      }
      this.visible = value;
    },
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
    visible(value) {
      this.$emit("input", value);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="less">
// 建议引入通用样式 具体路径自行修改 可删除下面样式代码
// @import "@/styles/drawer-common.less";
.drawer-footer {
  z-index: 10;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  background: #fff;
}

.drawer-content {
  overflow: auto;
}

.drawer-content::-webkit-scrollbar {
  display: none;
}

.drawer-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.drawer-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  display: block;
  margin-bottom: 16px;
}
</style>
